<template>
	<div class="auth-dialog__left-column d-flex flex-column justify-space-between">
		

		<img :src="AppConfigs.staticImages.LOGINPERSON" class="auth-dialog__login-person-image mt-15" />
		<AuthWelcomeMessage />
		<img :src="AppConfigs.staticImages.LOGINCOINBACKGROUND" class="auth-dialog__login-coin-background-image" />


	</div>
</template>



<script setup lang="ts">

import { AppConfigs } from "@/app.configs";
import AuthWelcomeMessage from '@/components/Auth/Common/Messeges/AuthWelcomeMessage.vue'

</script>